import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Asset } from "src/app/shared/models/asset";

@Injectable({
  providedIn: "root",
})
export class AssetService {
  constructor(private http: HttpClient) {}

  apiRoot = `${environment.apiUrl}Asset`;

  public createAsset(code: string, description: string): Observable<Asset> {
    return this.http.post<Asset>(
      `${this.apiRoot}/createAsset/code=${code}/description=${description}`,
      null
    );
  }

  public getAsset(code: string): Observable<Asset> {
    return this.http.get<Asset>(`${this.apiRoot}/getAsset/${code}`);
  }

  public getAllAssets(): Observable<Asset[]> {
    return this.http.get<Asset[]>(`${this.apiRoot}/getAllAssets`);
  }

  public deleteAsset(code: string): Observable<Asset> {
    return this.http.delete<Asset>(`${this.apiRoot}/deleteAsset/${code}`);
  }
}
